import React from 'react';
import { observer } from 'mobx-react';

type Props = {
  events: Array<Object>,
}
const EventLog = observer((props: Props) => (
  <div className="events">
    {props.events.slice().reverse().map(event => (
      <span className="event" key={event.timestamp}>{event.name}</span>
    ))}
    {props.placeholders &&
    <div className="placeholder-events">
      <span />
      <span />
      <span />
    </div>
    }
  </div>
));

export default EventLog;
